import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBag"><Path fillRule="evenodd" clipRule="evenodd" d="M7.2522 3V7H2V12H22V7H16.7522V3H7.2522ZM15.2522 7V4.5H8.7522V7H15.2522Z" fill="currentColor"/><Path d="M2 21V13.5H11.2507L11.2529 16.0007L12.7529 15.9993L12.7507 13.5H22V21H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBag;
